import styled from 'styled-components';
import ReachAccordionPrimitive from 'components/Reach/Accordion/ReachAccordion';
import { defaultCardContainerStyle } from '../DropOffCard/DropOffCard.styles';

export const Accordion = styled(ReachAccordionPrimitive.Root)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 5px; // for focus outline on tab
`;

export const AccordionItem = styled(ReachAccordionPrimitive.Item)`
  ${defaultCardContainerStyle}
`;

export const AccordionButton = styled(ReachAccordionPrimitive.Button)<{
  isMobile: boolean;
}>`
  position: relative;
  width: 100%;
  padding: ${({ isMobile }) => (isMobile ? '16px 10px' : '16px')};
`;

export const AccordionPanel = styled(ReachAccordionPrimitive.Panel)<{
  isMobile: boolean;
}>`
  padding: ${({ isMobile }) => (isMobile ? '16px 10px' : '16px')};
  padding-top: 0;
`;
